import authAxios from "../../../common/authAxios";
import { errorNotification } from "../../../helpers/errorNotification";
import { successNotification } from "../../../helpers/successNotification";

interface SummerRetakeApplicationsFilterParams {
    studentStatus: string;
    course: number | null;
    approved: number | null;
    startDate: string | null;
    endDate: string | null;
}

export class SummerRetakeApplicationService {
    private static baseUrlRetakeApplication = '/office-service/api/v1/summer-retake-application';


    static getRetakeDisciplinesForStudent(studentId: number) {
        return authAxios.get(`${this.baseUrlRetakeApplication}/summer-retake-disciplines/${studentId}`);
    }
    //http://localhost:8765/office-service/api/v1/summer-retake-application/summer-retake-disciplines/101

    static uploadFileRetakeApplication(formData: any) {
        return authAxios.post('/office-service/api/v1/summer-retake-application/upload-retake-application', formData)
    }

    static getRetakeStatusForStudent(studentId: number) {
        return authAxios.get(`${this.baseUrlRetakeApplication}/retake-applications-status-for-student/${studentId}`);
    }

    static getTotalCreditsForCurrentYear(studentId: number) {
        return authAxios.get(`${this.baseUrlRetakeApplication}/retake-applications-total-credits/${studentId}`);
    }

    static createRetakeApplication(fileId: number, disciplineId: number, creditAmount: number) {
        authAxios.post("/office-service/api/v1/summer-retake-application/create-summer-retake-application", { fileId, disciplineId, creditAmount })
            .then(() => {
                successNotification('Application accepted for consideration');
            })
            .catch((error) => {
                errorNotification(error.response.data.message);

            });
    }

    static fetchRetakeApplicationFilter(params: SummerRetakeApplicationsFilterParams) {
        return authAxios.get(`${this.baseUrlRetakeApplication}/summer-retake-applications-filter`, { params });
    }

    static moveToSecondStage(id: number) {
        return authAxios.put(`${this.baseUrlRetakeApplication}/decline-retake-application?id=${id}`);
    }

    static moveToThirdStage(id: number) {
        return authAxios.put(`${this.baseUrlRetakeApplication}/accept-retake-application?id=${id}`);
    }

    static addComment(id: number, comment: string) {
        return authAxios.put(`${this.baseUrlRetakeApplication}/add-comment?id=${id}&comment=${comment}`);
    }

    static fetchRetakeApplicationExcel(params: SummerRetakeApplicationsFilterParams) {
        return authAxios.get(`${this.baseUrlRetakeApplication}/retake-applications-excel`, {
            params,
            responseType: 'blob'
        });
    }

    static getStudentRetakeApplicationWord(studentId: number) {
        return authAxios.get(`${this.baseUrlRetakeApplication}/retake-applications-word/${studentId}`, {
            responseType: 'blob'
        });
    }


    static getFxExamStudentsByTeacherEmail(email: string) {
        return authAxios.get(`${this.baseUrlRetakeApplication}/fx-exam-students-by-teacher-mail/${email}`);
    }


    static declineApplicationByOfficeRegistrar(id: number) {
        return authAxios.put(`${this.baseUrlRetakeApplication}/decline-application-office-registrar?id=${id}`);
    }

    static acceptApplicationByOfficeRegistrar(id: number) {
        return authAxios.put(`${this.baseUrlRetakeApplication}/accept-application-office-registrar?id=${id}`);
    }

    static declineApplicationsByOfficeRegistrar(ids: number[]) {
        return authAxios.put(`${this.baseUrlRetakeApplication}/decline-applications-office-registrar-by-filter`, ids)
            .then(() => {
                successNotification('Applications successfully rejected');
            })
            .catch((error) => {
                errorNotification(error.response?.data?.message || 'Error rejecting applications');
            });
    }

    static acceptApplicationsByOfficeRegistrar(ids: number[]) {
        return authAxios.put(`${this.baseUrlRetakeApplication}/accept-applications-office-registrar-by-filter`, ids)
            .then(() => {
                successNotification('Applications successfully approved');
            })
            .catch((error) => {
                errorNotification(error.response?.data?.message || 'Error approving applications');
            });
    }




}